;(() => {
  const searchDropdown = document.querySelector('.search')
  const toggleSearch = document.querySelector('.toggle-search')
  const toggleSearchMobile = document.querySelector('.toggle-search-mobile')
  const searchDropdownClose = document.querySelector('.close-search')
  const html = document.documentElement

  function toggleDropdown(isOpen) {
    searchDropdown.classList.toggle('active', isOpen)
    html.classList.toggle('overflow-hidden', isOpen)

    if (isOpen) {
      document.querySelector('form#nosto-search input[type="search"]').focus()
      setTimeout(
        () => document.addEventListener('click', clickOutsideToClose),
        0
      )
    } else {
      document.removeEventListener('click', clickOutsideToClose)
    }
  }

  function clickOutsideToClose(event) {
    if (!event.target.closest('.shopify-section.search')) toggleDropdown(false)
  }

  toggleSearch.addEventListener('click', () =>
    toggleDropdown(!searchDropdown.classList.contains('active'))
  )
  toggleSearchMobile.addEventListener('click', () => toggleSearch.click())
  searchDropdownClose.addEventListener('click', () => toggleDropdown(false))

  const handleKeyup = debounce(async function (event) {
    const query = event.target.value
    if (query.length < 3) return
    shopifyPredictiveSearch(query)
    nostoSearch(query, false)
  })

  document
    .querySelector('form#nosto-search input[type="search"]')
    .addEventListener('keyup', handleKeyup)

  function nostoSearch(query, autocomplete = false) {
    nostojs(async (api) => {
      try {
        const response = await api.search(
          {
            query: query,
            products: {
              fields: [
                'name',
                'url',
                'imageUrl',
                'price',
                'listPrice',
                'onDiscount',
                'customFields.key', //this returns any metafields as a customFields array
                'customFields.value',
                'skus.id',
                'skus.name',
                'skus.imageUrl',
                'skus.price',
                'skus.listPrice',
                'skus.availability'
              ],
              size: 8
            },
            keywords: { fields: ['keyword'], size: 5 }
          },
          { track: autocomplete ? 'autocomplete' : 'serp' }
        )

        //filter out suggestion that is the same as the search query
        //this seems to be erroneously returned by the api
        const suggestions = response.keywords.hits.filter(
          (hit) => hit.keyword !== query
        )

        document
          .querySelector('.search .suggestions')
          .classList.toggle('active', suggestions.length > 0)

        document.querySelector('.search .suggestions .keywords').innerHTML =
          suggestions
            .map(
              (suggestion) =>
                `<button type="button" data-term="${suggestion.keyword}">${suggestion.keyword}</button>`
            )
            .join(' ')

        document.querySelector('#nosto-search-results').innerHTML =
          nostoResultsHtml(response?.products.hits, response.query)
        const showAllResultsLink = document.querySelector('a#show-all-results')
        document.querySelector('.mobile-search-header').hidden = false
        showAllResultsLink.href = `/search?q=${response.query}`
        showAllResultsLink.hidden = !response.products.total
        showAllResultsLink.querySelector('.results-count').innerHTML =
          response.products.total
      } catch (error) {
        console.error('nosto search error:', error)
      }
    })
  }

  async function shopifyPredictiveSearch(query) {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}search/suggest.json?q=${query}&resources[type]=query,collection,page,article`
      )
      const responseJson = await response.json()
      document.querySelector('#shopify-search-results').innerHTML =
        shopifyResultsHtml(responseJson)
    } catch (error) {
      console.error('shopify search error:', error)
    }
  }

  function nostoResultsHtml(products, query) {
    const formatter = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    })

    const formatPrice = (price) => formatter.format(price)

    function getFamilyName(customFields) {
      const fieldValue =
        customFields?.find((field) => field.key === 'filter-family')?.value ||
        '[""]'
      return JSON.parse(fieldValue)[0]
    }

    const productsHtml = products
      .map((product) => {
        let selection = product
        const variant = getSpecificVariant(product.skus, query)
        if (variant) {
          variant.url = `${product.url}?variant=${variant.id}`
          selection = variant
        }

        return `<a href="${selection.url}" class="product-search-result">
            <figure class="hover-zoom">
              <img 
              src="${selection.imageUrl}" 
              alt="${selection.name}" width="145px" />
            </figure>
            <div class="product-details">
              <strong class="no-padding-top">${getFamilyName(
                product.customFields
              )}</strong>
              <h6 class="no-padding-top">${selection.name}</h6>
              <div class="product-price">
                ${
                  selection.onDiscount
                    ? `<s class="light">${formatPrice(selection.listPrice)}</s>`
                    : ''
                }
                <strong>${formatPrice(selection.price)}</strong>
              </div>
            </div>
          </a>`
      })
      .join(' ')

    return (
      productsHtml ||
      `<div class="no-nosto-search-results"><h4>No Products Found</h4></div>`
    )
  }

  function shopifyResultsHtml(shopifyPredictiveSearchResponse) {
    const {
      resources: {
        results: { collections, pages, articles }
      }
    } = shopifyPredictiveSearchResponse

    const collectionsLinks = collections
      .map((collection) => {
        return `<a href="${collection.url}">${collection.title}</a>`
      })
      .join('')

    const pagesLinks = [...pages, ...articles]
      .map((page) => {
        return `<a href="${page.url}">${page.title}</a>`
      })
      .join('')

    const collectionsHtml = collectionsLinks.length
      ? `<div class="collections"><h6>COLLECTIONS</h6>${collectionsLinks}</div>`
      : ''
    const pagesHtml = pagesLinks.length
      ? `<div class="pages"><h6>BLOGS &amp; PAGES</h6>${pagesLinks}</div>`
      : ''

    return `${collectionsHtml}${pagesHtml}`
  }

  function debounce(func, timeout = 500) {
    let timer
    return (...args) => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        func.apply(this, args)
      }, timeout)
    }
  }

  function addSuggestionsClickHandlers(termButton) {
    termButton.addEventListener('click', function () {
      const searchTerm = this.dataset.term
      document.querySelector('form#nosto-search input[type="search"]').value =
        searchTerm
      nostoSearch(searchTerm, true)
    })
  }

  const suggestionButtonSelector = 'button[data-term]'
  const searchSuggestionButtonObserver = new MutationObserver(
    (mutationsList) => {
      mutationsList.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === Node.ELEMENT_NODE &&
            node.matches(suggestionButtonSelector)
          ) {
            addSuggestionsClickHandlers(node)
          }
        })
      })
    }
  )

  searchSuggestionButtonObserver.observe(
    document.querySelector('.search .suggestions .keywords'),
    {
      childList: true
    }
  )

  function getSpecificVariant(skus, query) {
    const variantWithQueryInName = skus.find((sku) =>
      sku.name.toLowerCase().includes(query.toLowerCase())
    )
    return variantWithQueryInName
  }
})()
